import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { AiReveniIcon, Text } from '@reveni-io/reveni-ui'

import CodeText from '../CodeText/CodeText'
import * as Styles from './styles'

const ReadyToUpdateContent = ({ proposedCode, proposedDescription }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.RightColumnMatch>
      <Styles.HeaderRecommendation>
        <AiReveniIcon size={14} />
        <Text type="allCapsM" color={theme.colors.text.muted}>
          {t('Recomendación')}
        </Text>
      </Styles.HeaderRecommendation>
      <Styles.DescriptionTextContainer>
        <CodeText code={proposedCode} variant="match" />
        {proposedDescription && (
          <Text type="bodyMRegular" color={theme.colors.text.default}>
            {proposedDescription}
          </Text>
        )}
      </Styles.DescriptionTextContainer>
    </Styles.RightColumnMatch>
  )
}

export default ReadyToUpdateContent
